import { Action, createReducer, on } from "@ngrx/store";
import { BauteilWithReports, FrontendReport } from "@partikelart/portal/shared-typing";
import * as ExportActions from "./export.actions";

export const exportFeatureKey = "export";

export interface PartsWithReports extends BauteilWithReports {
	selected: boolean;
}

export interface State {
	parts: PartsWithReports[];
	loadingParts: boolean;
	loadingReports: boolean;
}

export const initialState: State = {
	parts: [],
	loadingParts: false,
	loadingReports: false,
};

export const reducer = createReducer(
	initialState,

	on(ExportActions.loadPartsForUser, (state, action) => {
		return { ...state, loadingParts: true };
	}),
	on(ExportActions.loadPartsForArrayOfUsers, (state, action) => {
		return { ...state, loadingParts: true };
	}),
	on(ExportActions.loadExportsSuccess, (state, { partsForUser }) => {
		return { ...state, parts: partsForUser, loadingParts: false };
	}),
	on(ExportActions.loadExportsFailure, (state, action) => state),

	on(ExportActions.downloadReportsForPart, (state, action) => state),
	on(ExportActions.downloadReportForPartSuccess, (state, action) => {
		const index = state.parts.findIndex((part) => part.artnr == action.partNumber);
		if (index == -1) {
			return state; // No match found, should not occur, but we return state anyway
		}
		const updatedPartWithReports: BauteilWithReports = {
			...state.parts[index],
			reports: action.reports,
		};
		const updatedParts: BauteilWithReports[] = [
			...state.parts.slice(0, index),
			updatedPartWithReports,
			...state.parts.slice(index + 1),
		];
		return {
			...state,
			parts: updatedParts,
		};
	}),
	on(ExportActions.updateSelectionForSelectedPart, (state, action) => {
		const index = state.parts.findIndex((part) => part.artnr == action.partNumber);
		if (index == -1) {
			return state; // No match found, should not occur, but we return state anyway
		}
		const updatedPartWithReports: BauteilWithReports = {
			...state.parts[index],
			selected: action.selection,
		};
		const updatedParts: BauteilWithReports[] = [
			...state.parts.slice(0, index),
			updatedPartWithReports,
			...state.parts.slice(index + 1),
		];
		return {
			...state,
			parts: updatedParts,
		};
	}),
	on(ExportActions.updateSelectionForAllParts, (state, action) => {
		const parts = state.parts.map((part) => {
			return { ...part, selected: action.selection };
		});
		return { ...state, parts };
	}),
	on(ExportActions.getAllReportForSelectedParts, (state, action) => {
		return { ...state, loadingReports: true };
	}),
	on(ExportActions.getAllReportsForSelectedPartsSuccess, (state, action) => {
		const newStateOfParts: PartsWithReports[] = [];
		let i = 0;
		for (const part of state.parts) {
			if (part.selected) {
				newStateOfParts.push({ ...part, reports: action.arrayofReports[i] });
				i++;
			} else {
				newStateOfParts.push(part);
			}
		}
		return { ...state, parts: newStateOfParts, loadingReports: false };
	}),
);
